import { render, staticRenderFns } from "./startMake.vue?vue&type=template&id=5f7ea770&scoped=true"
import script from "./startMake.vue?vue&type=script&lang=js"
export * from "./startMake.vue?vue&type=script&lang=js"
import style0 from "./startMake.vue?vue&type=style&index=0&id=5f7ea770&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7ea770",
  null
  
)

export default component.exports